export interface ModelState {
  isLoading: boolean;
  isLoaded: boolean;
}

export enum LoadingState {
  initial = 1,
  loading,
  loaded,
  failed
}
